export default "__VITE_ASSET__0a2efb94__"